<nav class="nb-shell no-select">
  <!-- scanline overlay (dark mode only) -->
  <div class="nb-scanlines"></div>

  <!-- ══ INNER ══ -->
  <div class="nb-inner d-flex align-items-center w-100 px-2 px-md-3 gap-2">
    <!-- ── BRAND ── -->
    <a class="nb-brand d-flex align-items-center gap-2 text-decoration-none flex-shrink-0" routerLink="/">
      <span class="nb-brand__icon bi bi-controller"></span>
      <ng-template [ngIf]="urlParserService.isParlyEngage || urlParserService.isEngageHub">
        <img class="nb-brand__logo" src="assets/img/logo-with-name.svg" alt="parly gamification" />
      </ng-template>
    </a>

    <!-- ── NAV LINKS (md+) ── -->
    <ul class="nb-nav d-none d-md-flex align-items-center gap-1 mb-0 ps-0 list-unstyled ms-3">
      <li *ngIf="auth.isAdmin()" [routerLinkActive]="['nb-nav__item--active']">
        <a class="nb-nav__link" routerLink="/admin/manage/user">
          <i class="bi bi-shield-fill nb-nav__icon"></i>
          <span>{{ 'NAVBAR.TEAM_ADMIN_LINK' | translate }}</span>
        </a>
      </li>
      <li *ngIf="auth.isAdmin()" [routerLinkActive]="['nb-nav__item--active']">
        <a class="nb-nav__link" routerLink="/admin/gamification/settings">
          <i class="bi bi-trophy-fill nb-nav__icon"></i>
          <span>{{ 'NAVBAR.GAMIFICATION_LINK' | translate }}</span>
        </a>
      </li>
    </ul>

    <!-- ── SPACER ── -->
    <div class="flex-grow-1"></div>

    <!-- ── RIGHT CONTROLS ── -->
    <div class="d-flex align-items-center gap-1 gap-md-2">
      <!-- Theme toggle *ngIf="isLoggedIn"-->
      <button
        
        type="button"
        class="nb-icon-btn"
        [title]="isDark ? 'Switch to Light' : 'Switch to Dark'"
        (click)="toggleTheme()"
      >
        <i [class]="isDark ? 'bi bi-sun-fill' : 'bi bi-moon-stars-fill'"></i>
      </button>

      <!-- Language -->
      <button type="button" class="nb-icon-btn" mat-button [matMenuTriggerFor]="langMenu">
        <i class="bi bi-translate"></i>
      </button>
      <mat-menu #langMenu="matMenu" class="nb-mat-menu">
        <button
          *ngFor="let lang of translate.getLangs()"
          mat-menu-item
          [class.nb-lang--active]="lang === translate.currentLang"
          (click)="translate.use(lang)"
        >
          {{ lang }}
        </button>
      </mat-menu>

      <!-- Profile -->
      <div *ngIf="isLoggedIn" class="nb-profile dropdown" ngbDropdown placement="bottom-right">
        <button class="nb-profile__btn d-flex align-items-center gap-2" type="button" ngbDropdownToggle>
          <!-- avatar -->
          <div class="nb-profile__avatar">
            <app-user-template
              *ngIf="auth.userProfile?.userData?.avatarUrl || auth.userProfile?.avatarUrl; else avatarFallback"
              class="icon-32"
              [user]="auth.userProfile"
              [displayUserName]="false"
              tooltipField="userData.status"
            ></app-user-template>
            <ng-template #avatarFallback>
              <i class="bi bi-person-circle nb-profile__avatar-icon"></i>
            </ng-template>
          </div>
          <!-- name — hidden on xs -->
          <span class="nb-profile__name d-none d-sm-inline">{{ auth.getDisplayName() }}</span>
          <i class="bi bi-chevron-down nb-profile__caret d-none d-sm-inline"></i>
        </button>

        <!-- Dropdown -->
        <div class="nb-dropdown dropdown-menu" ngbDropdownMenu>
          <!-- header row -->
          <div class="nb-dropdown__header d-flex align-items-center justify-content-between px-3 py-2">
            <div>
              <div class="nb-dropdown__username">{{ auth.getDisplayName() }}</div>
              <div class="nb-dropdown__role">{{ auth.getDisplayRole() }}</div>
            </div>
            <div class="nb-dropdown__level" *ngIf="auth.rewards?.level?.icon" [matTooltip]="auth.rewards?.level?.name">
              <app-s3-image [fitContain]="true" [image]="auth.rewards?.level?.icon"></app-s3-image>
            </div>
          </div>

          <div class="nb-dropdown__divider"></div>

          <a class="nb-dropdown__item" routerLink="/profile" ngbDropdownItem>
            <i class="bi bi-person-fill"></i>
            {{ 'NAVBAR.PROFILE_LINK' | translate }}
          </a>

          <a class="nb-dropdown__item" routerLink="/admin/settings" *ngIf="auth.isAdmin()" ngbDropdownItem>
            <i class="bi bi-gear-fill"></i>
            {{ 'NAVBAR.SETTINGS_LINK' | translate }}
          </a>

          <div class="nb-dropdown__divider"></div>

          <button
            type="button"
            class="nb-dropdown__item nb-dropdown__item--danger w-100"
            (click)="signOut()"
            ngbDropdownItem
          >
            <i class="bi bi-box-arrow-right"></i>
            {{ 'NAVBAR.LOGOUT_LINK' | translate }}
          </button>
        </div>
      </div>
    </div>
    <!-- /right controls -->
  </div>
  <!-- /inner -->
</nav>
